import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const MembershipMemberMappingBasicInfoComponent = ({ users, membershipType, membership, handleInnerFormChange, selectedMembershipMemberMappings }: any) => (
        <>
  <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Membership Name"
              labelField="Name"
              list={membership}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipId'
                )
              }}
              optionName='Choose Membership'
              type="select"
              value={selectedMembershipMemberMappings?.MembershipId}
              valueField="Id"
          />
     <InputContainer
              label="Membership Type Name"
              labelField="Name"
              list={membershipType}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipTypeId'
                )
              }}
              optionName='Choose MembershipType'
              type="select"
              value={selectedMembershipMemberMappings?.MembershipTypeId}
              valueField="Id"
          />
     <InputContainer
              label="User Profile"
              labelField="Email"
              list={users}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfileId'
                )
              }}
              optionName='Choose UserProfile'
              type="select"
              value={selectedMembershipMemberMappings?.UserProfileId}
              valueField="Id"
          />
     <InputContainer
            label="Start Date"
            labelField="StartDate"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'StartDateUtc'
              );
            }}
            type="date"
            value={selectedMembershipMemberMappings?.StartDateUtc}
        />
     <InputContainer
            label="End Date"
            labelField="End Date"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'EndDateUtc'
              );
            }}
            type="date"
            value={selectedMembershipMemberMappings?.EndDateUtc}
        />
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Information"
/>
        </>
)
export default MembershipMemberMappingBasicInfoComponent;
